function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.12 46.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m27.06,46.28c-.46,0-.91-.16-1.28-.47L5.91,29.17C2.53,26.34.45,22.36.07,17.97c-.39-4.39.96-8.67,3.79-12.06C6.69,2.53,10.67.45,15.06.07c4.37-.39,8.63.94,12,3.75,6.98-5.8,17.38-4.87,23.21,2.1,5.85,6.98,4.92,17.41-2.05,23.26l-19.87,16.64c-.37.31-.83.47-1.28.47ZM16.53,4c-.37,0-.75.02-1.12.05-3.33.29-6.34,1.87-8.49,4.43-2.15,2.56-3.17,5.81-2.87,9.13.29,3.33,1.87,6.34,4.43,8.49l18.59,15.57,18.59-15.57c5.29-4.43,5.99-12.34,1.56-17.62-4.43-5.29-12.34-5.99-17.62-1.56l-1.23,1.03c-.74.62-1.83.62-2.57,0l-1.23-1.03c-2.27-1.9-5.08-2.92-8.01-2.92Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.a54e9725.svg";
export { ForwardRef as ReactComponent };